import { atom } from "recoil";
import { InstObject } from "../config/types";
const default_Insts: InstObject[] = [];
const default_string_array: string[] = [];

export const selectedInstsR = atom({
    key: "selectedInstsR",
    default: default_Insts,
});
export const selectedInstsKeptR = atom({
    key: "selectedInstsKeptR",
    default: default_Insts,
});
export const selectedInstsAnalysisR = atom({key: "selectedInstsAnalysisR", default: default_Insts});
export const selectedInstsNameAnalysisR = atom({key: "selectedInstsNameAnalysisR", default: default_Insts});

export const colorPaletteR = atom({key: "colorPaletteR", default: default_string_array});
